// src/context/ThemeColorContext.jsx
import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const ThemeColorContext = createContext();

export const ThemeColorProvider = ({ children }) => {
  const [colors, setColors] = useState({
    darkPrimary: "#3B0764",
    darkSecondary: "#581C87",
    darkAccent: "#9333EA",
    darkText: "#ffffff",

    lightPrimary: "#ffffff",
    lightSecondary: "#f9f9f9",
    lightAccent: "#7c3aed",
    lightText: "#1e1b4b",
  });

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/site-setting/`)
      .then((res) => {
        setColors((prev) => ({
          ...prev,
          darkPrimary: res.data.dark_primary || prev.darkPrimary,
          darkSecondary: res.data.dark_secondary || prev.darkSecondary,
          darkAccent: res.data.dark_accent || prev.darkAccent,
          darkText: res.data.dark_text_color || prev.darkText,

          lightPrimary: res.data.light_primary || prev.lightPrimary,
          lightSecondary: res.data.light_secondary || prev.lightSecondary,
          lightAccent: res.data.light_accent || prev.lightAccent,
          lightText: res.data.light_text_color || prev.lightText,
        }));
      })
      .catch((err) => console.error("Error loading theme colors:", err));
  }, []);

  return (
    <ThemeColorContext.Provider value={colors}>
      {children}
    </ThemeColorContext.Provider>
  );
};

export const useThemeColors = () => useContext(ThemeColorContext);
